import React from "react";
import CarouselGallery from "../component/Carousel";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

function Gallery() {
	return (
		<div>
			<Navbar />
      <CarouselGallery />
      <Footer />
		</div>
	);
}

export default Gallery;
